import dayjs from 'dayjs';

/**
 * 转换时间数据
 *
 * @param {number} currentTime 当前时间戳
 * @param {Array} tradeTimeList 交易时间列表
 * @returns {Object} 格式化后的时间数据
 */
export function convertTradeTime(currentTime, tradeTimeList) {
  const result = {};

  tradeTimeList.forEach((item, index) => {
    const timeGroup = [];

    // 根据时间段（time）和 subTime（子时间），计算对应的时间戳
    item.subTime.forEach((time) => {
      const [hour, minute] = time.split(':');
      // 使用 dayjs 处理时间，并确保跨天计算
      let timestamp = dayjs(currentTime * 1000)
        .hour(hour)
        .minute(minute)
        .second(0)
        .millisecond(0)
        .unix();

      console.log('timestamp', timestamp, currentTime);
      // 如果生成的时间戳小于当前时间戳，表示是跨天的时间，需要加上一天
      if (timestamp <= currentTime) {
        timestamp += 24 * 60 * 60; // 增加一天的秒数
      }

      timeGroup.push({
        time: timestamp * 1000,
        str: time,
      });
    });

    result[index + 1] = timeGroup; // 按照index+1的方式存储
  });

  return result;
}
